/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TagIcon20Light = forwardRef('TagIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.185 4a3 3 0 0 0-2.322 1.1L1.149 8.417a2.5 2.5 0 0 0 0 3.166L3.863 14.9A3 3 0 0 0 6.185 16H15a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H6.185ZM4.637 5.734A2 2 0 0 1 6.185 5H15a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6.185a2 2 0 0 1-1.548-.733L1.923 10.95a1.5 1.5 0 0 1 0-1.9l2.714-3.316Z" })));
});
